
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvTaskRegistrationForm.html?raw';

import { ApplicatonMode, EvTaskTypes, InfoPanel } from "../../_loadingHelpers/EvTask";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { ToasterHelpers } from "../../../more/Helpers";


class EvTaskRegistrationForm extends compose(_StatefulSection) {
    templateString: any = template;

    private actionContainer: HTMLElement;
    private btnApplyForTask: HTMLButtonElement;
    private btnRemoveApplication: HTMLButtonElement;

    private entityID: string = null;
    private entityData: EvTaskTypes.InfoPanelData;
    private infoPanelLoaded: boolean = false;

    infoPanel: MdsLax<InstanceType<typeof InfoPanel>>;

    setup(evTaskID: string) {
        this.entityID = evTaskID;
        this.loadData();
    }

    loadData() {
        if (this.entityID) {
            this.setStartupState("loading");

            this.StandbyStart();
            this.infoPanel.loadById(this.entityID);
        }
    }

    private _onLoadedInfoPanel(data: EvTaskTypes.InfoPanelData) {
        this.infoPanelLoaded = true;
        this.setData(data);
    }

    afterSetData() {
        this.StandbyStop();

        let data = this.sourceData as EvTaskTypes.InfoPanelData;
        this.entityData = data;
        
        this.hideNode(this.actionContainer, !this.entityData);

        this.UiModder.domClass.remove(this.actionContainer, "w3-disabled");

        this.UiModder.domClass.toggle(this.btnApplyForTask, "w3-disabled", !this.entityData?.canApply);
        this.UiModder.domClass.toggle(this.btnRemoveApplication, "w3-disabled", !this.entityData?.canRemoveApplication);


        if (!this.infoPanelLoaded) {
            this.infoPanelLoaded = true;
            this.infoPanel.setData(data);
        }
    }

    private _onClick_RemoveApplication(evt: MouseEvent) {
        this.saveApplication(ApplicatonMode.remove);
    }

    private _onClick_ApplyForTask(evt: MouseEvent) {
        this.saveApplication(ApplicatonMode.apply);
    }

    private saveApplication(mode: ApplicatonMode) {
        this.UiModder.domClass.add(this.actionContainer, "w3-disabled");

        this.StandbyStart();
        this.emit("saving");

        let data = {
            applyMode: mode,
            evTaskID: this.entityID
        };


        this.RequestManager.post(
            window.appRoot + "EvTask/ApplyForTask",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onSaveApplicationResponse),
            lang.hitch(this, this._onSaveApplicationError)
        );
    }

    private _onSaveApplicationResponse(response) {
        this.StandbyStop();

        this.emit("saved", true);

        this.showToast({
            title: this.translations["General__SaveSuccess"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        this.loadData();
    }

    private _onSaveApplicationError(error: more.requestErrorMessage) {
        this.StandbyStop();

        this.UiModder.domClass.remove(this.actionContainer, "w3-disabled");


        this.showToast({
            title: this.translations["General__ProcessFailed"],
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message
        });

        this.emit("saved", false);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskRegistrationForm);